import http from '@/libs/http'
export default class ContratoAutorizacionServices {
  getContratoAutorizacion () {
    return http.get(`${process.env.VUE_APP_MICROSERVICE_API_FACTURACION}/contrato_autorizacion`)
  }
}
